import { OidcClient } from './client'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(<any>window)['NUGSNET_OIDC_CLIENT'] = OidcClient

export { OidcClient }
